import React, { useState } from "react";
import { Tooltip } from 'react-tooltip';
import { differenceInDays } from "date-fns/differenceInDays";
//Components
import Text from "components/Text";
import { BackButton } from "../components/generics/BackButton";
import ReportLayoutIndicator from "../components/ReportLayoutIndicator";
//utils
import { DateOutputStr } from "utils/DateOutput";
import { generateRandomId } from "utils/GenerateRandomId";
//interfaces
import { IReportPage } from "./interface";
import { automatic, orders, simplifiedAutomaticAnswer } from "./buttons";
//services
import ReportService from "services/report.service";
//styles
import { CleanFilters, DateFilter, DateLabel, IndicatorArea, ReportsContent, Title } from "./styles";

export const ReportsPage: React.FC<IReportPage> = (props) => {
  const { startDate, endDate } = props;

  const _reportServices = new ReportService();

  const [period, setPeriod] = useState({
    startDate: startDate ? DateOutputStr(startDate.toISOString(), 'yyyy-MM-dd') : '',
    endDate: endDate ? DateOutputStr(endDate.toISOString(), 'yyyy-MM-dd') : '',
  });

  const [filterTooltip, setFilterTooltip] = useState('');

  async function requestReport(reportType: number) {
    const intervalInDays = Math.abs(differenceInDays(new Date(period.startDate), new Date(period.endDate))) + 1;
    let startDate = period.startDate;
    let endDate = period.endDate;
    if (Number.isNaN(intervalInDays)) {
      let current = new Date();
      let pastDate = new Date();
      pastDate.setDate(pastDate.getDate() - 30);
      startDate = DateOutputStr(pastDate.toISOString(), 'yyyy-MM-dd');
      endDate = DateOutputStr(current.toISOString(), 'yyyy-MM-dd');
    } else if (intervalInDays > 31) {
      return false;
    }
    const model = {
      startDate: startDate,
      endDate: endDate,
      type: reportType
    };

    await _reportServices.DownloadPortalReport(model);
  }

  const makeFilter = () => {
    const intervalInDays = Math.abs(differenceInDays(new Date(period.startDate), new Date(period.endDate))) + 1;
    if (Number.isNaN(intervalInDays))
      setFilterTooltip('Preencha os campos de período');
    else if (intervalInDays > 31)
      setFilterTooltip('O intervalo máximo é de 31 dias');
  };

  const clearFilter = () => {
    setPeriod({ startDate: '', endDate: '' });
    setFilterTooltip('');
  };

  const tooltipId = generateRandomId("ReactTooltip");

  return (
    <ReportsContent>
      <BackButton />
      <Title>Relatórios</Title>
      <DateFilter>
        <DateLabel>Período<br />(Máx. de 31 dias)</DateLabel>
        <input
          value={period.startDate}
          onChange={(e) => {
            setPeriod({ ...period, startDate: e.target.value });

          }}
          type="date"
          max={period.endDate}
        />
        <DateLabel>a</DateLabel>
        <input
          value={period.endDate}
          onChange={(e) => {
            setPeriod({ ...period, endDate: e.target.value });
          }}
          type="date"
          min={period.startDate}
        />
        <>
          <button
            onClick={() => makeFilter()}
            className="button bg-cyanLightViveo w-sm-70 w-md-40 w-40 filter-button"
            data-tooltip-id={tooltipId}
            role={'button'}
            data-tooltip-content={filterTooltip}
            data-tooltip-place={'top'}
            style={{
              height: '40px',
              width: '85px',
              marginRight: '20px'
            }}>
            <Text
              size={14}
              className="button-text color-primary font-bold"
            >
              Filtrar
            </Text>
          </button>
          <Tooltip
            openOnClick
            id={tooltipId}
            variant="light"
            afterHide={() => setFilterTooltip("")}
          />
        </>
        <CleanFilters onClick={() => clearFilter()}>Limpar filtros</CleanFilters>
      </DateFilter>
      <IndicatorArea>
        <ReportLayoutIndicator
          key="simpleReportRA"
          data={simplifiedAutomaticAnswer}
          onClick={() => requestReport(0)}
        />
        <ReportLayoutIndicator
          key="reportDPI"
          data={automatic}
          onClick={() => requestReport(2)}
        />
        <ReportLayoutIndicator
          key="reportOrders"
          data={orders}
          onClick={() => requestReport(3)}
        />
      </IndicatorArea>
    </ReportsContent>
  );
};